import { create } from 'zustand';
import { ShoppingItemData } from '../types/api';

interface ShoppingStore {
  items: ShoppingItemData[];
  setItems: (items: ShoppingItemData[]) => void;
  addItem: (text: string) => void;
  toggleItem: (id: string) => void;
  deleteItem: (id: string) => void;
}

export const useShoppingStore = create<ShoppingStore>((set) => ({
  items: [],
  setItems: (items) => set({ items }),
  addItem: (text) =>
    set((state) => ({
      items: [
        ...state.items,
        {
          id: Date.now().toString(),
          name: text,
          completed: false,
        },
      ],
    })),
  toggleItem: (id) =>
    set((state) => ({
      items: state.items.map((item) =>
        item.id === id ? { ...item, completed: !item.completed } : item
      ),
    })),
  deleteItem: (id) =>
    set((state) => ({
      items: state.items.filter((item) => item.id !== id),
    })),
})); 